import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Box, Container, Paper } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    container: {
        paddingTop: '5rem',
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
    },
    paper: {
        padding: '3rem',
        marginBottom: '1rem',
        maxWidth: '600px',
        width: '100%',
        textAlign: 'center',
        backgroundColor: '#fff',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    },
    paragraph: {
        fontSize: '1.6rem',
        lineHeight: 1.6,
        marginBottom: '1.5rem',
        color: '#4a4a4a',
    },
    infoText: {
        fontSize: '1.4rem',
        lineHeight: 1.6,
        marginBottom: '1rem',
        color: '#3273dc',
        fontStyle: 'italic',
    },
}));

export default function EmailSent() {
    const classes = useStyles();
    let email = sessionStorage.getItem('email');

    return (
        <Container className={classes.container}>
            <Paper className={classes.paper} elevation={1}>
                <Typography variant="body1" className={classes.paragraph}>
                    登録されたEメールアドレス{email ? `(${email})` : ''}に認証用URLを送信致しました。
                </Typography>
                <Typography variant="body1" className={classes.paragraph}>
                    メール本文に記載されたリンクをクリックして、アカウントの認証を行ってください。
                </Typography>
                <Box style={{ marginTop: '2rem' }}>
                    <Typography variant="body2" className={classes.infoText}>
                        ※認証リンクは24時間のみ有効です
                    </Typography>
                    <Typography variant="body2" className={classes.infoText}>
                        ※メールが届かなかった場合、迷惑メールに振り分けられていないかご確認ください
                    </Typography>
                    <Typography variant="body2" className={classes.infoText}>
                        ※通信状況によってはメールが届くまで5分程度かかる事がございます。もし長時間待っても届かない場合は、恐れ入りますが問い合わせフォームからご連絡ください。
                    </Typography>
                </Box>
            </Paper>
        </Container>
    )
}
